<template>
  <div class="automatic-translation-progress-report"
    v-if="progress && loggedInUser && enabledLanguages && enabledLanguages.length > 1 && automaticTranslationsAreEnabled">

    <div class="label" v-text="$t('automatic-translation-progress-report-label')"></div>
    <div class="progress-section">
      <div class="progress-label">
        <span class="done" v-text="progress.done"></span> / <span class="total" v-text="progress.total"></span>
      </div>
      <div class="progress-bar-container">
        <div class="progress-bar" :style="{width: Number.parseInt(progress.percentage) + '%' }"></div>
      </div>
    </div>

  </div>





</template>

<script setup>
import translationProgressService from "../composables/translationProgressService"
import translationService from "../composables/translationService"
let { enabledLanguages } = translationService()
</script>
<script>



export default {
  data() {
    return {}
  },
  watch: {},
  async unmounted() { },
  async mounted() { },

  computed: {
    progress() {
      return translationProgressService.document && translationProgressService.document.value
    },
    automaticTranslationsAreEnabled() {
      return true
      return this.companySettings && this.companySettings.i18n && this.companySettings.i18n.enableAutomaticTranslation
    },
  },
  methods: {

  },

}
</script>
<style scoped>

.automatic-translation-progress-report {
  font-size: 0.8rem;
  font-weight: 300;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem 0.5rem 0.3rem 3.3rem;
  border-top: 1px solid #ddd;
  position: relative;

}

.automatic-translation-progress-report .label {
  flex: 1;
  text-align: left;
  padding-right: 1.5rem;
}

.progress-section{
  width: 80px;
  position: relative;  
}
.progress-section .progress-label{
  text-align: right;
  font-size: 0.7rem;
  display: none;

}
.progress-bar-container{
  background-color: var(--ion-color-light);
  border-radius: 1.5px;
  height: 10px;
  width: 100%;
  position: relative;
}
.progress-bar{
  background-color: var(--ion-color-primary);  
  border-radius: 1.5px;
  height: 10px;  
}
</style>
